module.exports = __webpack_public_path__ + "static/11-6c58f25fbda56e7b4a90f8d123906f8a.jpg";